import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "@phosphor-icons/react";

const FAQ_ITEMS = [
  { q: "How quickly can I get my permit after completing the course?", a: "Processing times vary by state. Maryland typically issues permits in 60-90 days after a completed application. We provide all required certification documentation immediately upon course completion." },
  { q: "Do I need to be a U.S. citizen to enroll?", a: "Most courses require legal U.S. residency. Citizenship requirements vary — Florida and Arizona accept legal residents, while some other states require U.S. citizenship. We verify eligibility during registration." },
  { q: "Are firearms and ammunition provided?", a: "Loaner firearms and range ammunition can be provided for an additional fee. Students are welcome to bring their own firearm (must be safe-checked by instructors prior to live fire)." },
  { q: "What's the difference between Wear & Carry and Concealed Carry?", a: "Terminology varies by state. Maryland uses 'Wear & Carry' for what other states call 'Concealed Carry Permit' (CCW) or 'Concealed Handgun Permit' (CHP). The course content meets each state's statutory training requirement." },
  { q: "Can my company book private group training?", a: "Yes. We deliver private security officer training and corporate workplace-violence-prevention courses on-site. Contact our operations team for custom curriculum." },
  { q: "Do you offer payment plans on your courses?", a: "Yes — every course supports a 50% deposit at checkout to reserve your seat. The balance is due before your class date, payable anytime from your dashboard." },
];

export { FAQ_ITEMS };

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <div className="space-y-2" data-testid="faq">
      {FAQ_ITEMS.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className="border border-white/10 bg-[#141414] overflow-hidden" data-testid={`faq-item-${i}`}>
            <button
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="w-full p-6 flex items-center justify-between text-left hover:bg-white/[0.02] transition-colors"
              data-testid={`faq-toggle-${i}`}
            >
              <div className="flex items-center gap-4">
                <span className="font-mono text-xs text-[#FFD300]">Q{String(i+1).padStart(2,'0')}</span>
                <span className="font-heading text-lg tracking-tight pr-4">{item.q}</span>
              </div>
              <div className="flex-shrink-0">
                {isOpen ? <Minus size={20} className="text-[#FFD300]" /> : <Plus size={20} className="text-neutral-400" />}
              </div>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <div className="px-6 pb-6 pl-16 text-neutral-300 leading-relaxed">{item.a}</div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
